import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

/**
 * One-time AG Grid setup, imported for its side effects by ComponentModule.
 *
 * - Registers every Community + Enterprise module globally, so grids no longer
 *   pass their own `[modules]` list.
 * - Keeps the CSS-file themes (`ag-theme-balham`) that SOL's sol-core.scss
 *   loads; the Lyra look is applied through `--ag-*` variables in grid.scss.
 *
 * The Enterprise licence key is set by SOL's GridModule (imported in
 * ComponentModule), which carries the CXone-wide key.
 */
ModuleRegistry.registerModules([AllEnterpriseModule]);
provideGlobalGridOptions(
  {
    theme: 'legacy',
    // Under AG Grid 31 the grids only registered Clipboard / RangeSelection
    // (+ RowGrouping / ExcelExport), so there was no grid context menu (the
    // browser's own menu showed) and no column menu. AllEnterpriseModule brings
    // both in; keep them off so right-click, Alt+Down and the header ARIA
    // descriptions behave as before.
    suppressContextMenu: true,
    defaultColDef: {
      suppressHeaderMenuButton: true,
      suppressHeaderContextMenu: true,
    },
  },
  // Deep merge, so the grids' own defaultColDef keeps these two flags.
  'deep',
);
